import { withInstall } from '/@/utils/index';
import tooltipComponent from './src/Tooltip.vue';

export const Tooltips = withInstall(tooltipComponent);